import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from 'src/app/https.service';
import { URLUtils } from 'src/app/urlUtils';
import { ToastrService } from 'ngx-toastr';

interface Lead {
  name: string;
  type: 'Entity' | 'Lawyer';
  email: string;
  status: string;
  specialization: string;
  contactNumber?: string;
  address?: string;
  additionalDetails?: string;
  firmName?: string;
  firmEmail?: string;
  registrationNumber?: string;
  contactPerson?: string;
  designation?: string;
  numberOfLawyers?: number;
  needLawyerDetails?: boolean;
  licenseNumber?: string;
}
@Component({
  selector: 'app-add-lead-modal',
  templateUrl: './add-lead-modal.component.html',
  styleUrls: ['./add-lead-modal.component.css']
})
export class AddLeadModalComponent {
  leadForm!: FormGroup;
  leadType: 'Entity' | 'Lawyer' = 'Entity';
  
  specializations:any[]= [];
    // 'Criminal Law', 
    // 'Civil Law', 
    // 'Corporate Law', 
    // 'Family Law', 
    // 'Immigration Law', 
    // 'IP Law',
    // 'Tax Law',
    // 'Real Estate Law',
    // 'Banking Law',
    // 'Other'
  // ];

  countries: string[] = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola",
    "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
    "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus",
    "Belgium", "Belize", "Benin", "Bhutan", "Bolivia",
    "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
    "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon",
    "Canada", "Central African Republic", "Chad", "Chile", "China",
    "Colombia", "Comoros", "Congo (Brazzaville)", "Congo (Kinshasa)", "Costa Rica",
    "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark",
    "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt",
    "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini",
    "Ethiopia", "Fiji", "Finland", "France", "Gabon",
    "Gambia", "Georgia", "Germany", "Ghana", "Greece",
    "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
    "Haiti", "Honduras", "Hungary", "Iceland", "India",
    "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
    "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan",
    "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos",
    "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",
    "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi",
    "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands",
    "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova",
    "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique",
    "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands",
    "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea",
    "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",
    "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru",
    "Philippines", "Poland", "Portugal", "Qatar", "Romania",
    "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines",
    "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal",
    "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia",
    "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea",
    "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname",
    "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan",
    "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga",
    "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
    "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States",
    "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela",
    "Vietnam", "Yemen", "Zambia", "Zimbabwe"
  ];
  departmentsMap:any[]=[];

  constructor(
    private fb: FormBuilder,private toastr: ToastrService,
    public activeModal: NgbActiveModal,
    private httpService: HttpService
  ) { }

  ngOnInit() {
    this.initializeForm();
    this.getDept();
  }
  
getDept() {
  const uid = localStorage.getItem('profuid');
  this.httpService.sendGetRequest(URLUtils.getGroups).subscribe((res: any) => {
    const departments = res.data || [];

    // Clear and repopulate departmentsMap
    this.departmentsMap = [];

    // Filter out 'AAM' and 'SuperUser'
    this.specializations = departments
      .filter((dept: any) => dept.name !== 'AAM' && dept.name !== 'SuperUser')
      .map((dept: any) => {
        this.departmentsMap[dept.id] = dept.name;
        return dept.name === 'I am not sure' ? 'Other' : dept.name;
      });
    console.log('Departments:', this.specializations);
  });
}

  initializeForm() {
    // Common fields for both entity and lawyer
    const solo = {
      name: ['', [Validators.required]],
      firmEmail: ['', [Validators.required]],
      specialization: ['', [Validators.required]],
      contactNumber: ['', [Validators.pattern('^[0-9]{10}$')]],
      address: [''],
      additionalDetails: [''],
      status: [''],
      addressType: [''],
      houseFlatNo: [''],
      street: [''],
      landmark: [''],
      city: [''],
      state: [''],
      country: [''],
      zipcode: ['']
    };

    const entity = {
      name: ['', [Validators.required]],
      firmEmail: ['', [Validators.required]],
      specialization: ['', [Validators.required]],
      contactNumber: ['', [Validators.pattern('^[0-9]{10}$')]],
      address: [''],
      additionalDetails: [''],
      status: [''],
      addressType: [''],
      houseFlatNo: [''],
      street: [''],
      landmark: [''],
      city: [''],
      state: [''],
      country: [''],
      zipcode: ['']
    };

    
    if (this.leadType === 'Entity') {
      this.leadForm = this.fb.group({
        ...entity,
        firmName: ['', [Validators.required]],
        firmEmail: ['', [Validators.required, Validators.email]],
        registrationNumber: ['', [Validators.required]],
        contactPerson: [''],
        designation: [''],
        numberOfLawyers: [0, [Validators.min(0)]],
        needLawyerDetails: [false]
      });
    } else {
      this.leadForm = this.fb.group({
        ...solo,
        licenseNumber: ['', [Validators.required]]
      });
    }
  }
  
  toggleLeadType(type: 'Entity' | 'Lawyer') {
    if (this.leadType !== type) {
      this.leadType = type;
      this.initializeForm();
    }
  }
  
  submitForm() {
   // console.log('form value',this.leadForm.value)
  //  if (this.leadForm.valid) {
      const formValues = this.leadForm.value;
      console.log('formval',formValues)

      const address = {
        address_type: formValues?.addressType || '',
        house_flat_no: formValues?.houseFlatNo || '',
        street: formValues?.street || '',
        landmark: formValues?.landmark || '',
        city_town: formValues?.city || '',
        state: formValues?.state || '',
        country: formValues?.country || '',
        zipcode: formValues?.zipcode || ''
      };
      //console.log('address',address)
  
      const payload: any = {
        fullname: formValues.name,
        email: formValues.firmEmail,
        contact_phone: formValues.contactNumber,
        contact_person: formValues.contactPerson,
        tin: this.leadType === 'Entity' ? formValues.registrationNumber : formValues.licenseNumber,
        address: address,
        status: formValues.status,
        category: this.leadType.toLowerCase(), // "entity" or "solo"
        subcategory: formValues.specialization ? [formValues.specialization] : [],
        notes: '',
        country: formValues.country || '',
        additional_category: formValues.additionalDetails || '',
        designation: formValues.designation || '', 
        no_of_lawyers: formValues.numberOfLawyers,
        name: formValues.firmName
      };
     // console.log('payload',payload)

      // if (this.leadType === 'Entity') {
      //   payload.name = formValues.firmName;
      //   payload.no_of_lawyers = formValues.numberOfLawyers;
      //   payload.designation = formValues.designation;
      // }

      // Use Angular HttpClient to POST
      this.httpService.sendPostRequest(URLUtils.leadslawyers(), payload).subscribe({
        next: (res:any) => {
          if (!res.error) {
            //console.log('Success:', res);
            // this.toastr.success('Lead added successfully');

            // ✅ Toast message based on category
            if (payload.category === 'entity') {
              this.toastr.success('Lead added successfully');
            } else if (payload.category === 'lawyer' || payload.category === 'solo') {
              this.toastr.success('Lawyer added successfully');
            } else {
              this.toastr.success('Data added successfully'); // fallback
            }

            this.activeModal.close(res);
          } else {
            //console.error('Error submitting lead:');
          }
        },
        error: (error) => {
          // Check if API provided a structured error message
          if (error.error?.errors && Array.isArray(error.error.errors)) {
            // Loop through the errors and display each message
            error.error.errors.forEach((err: any) => {
              if (err.msg) {
                this.toastr.error(err.msg);
              } else {
                this.toastr.error('An error occurred.');
              }
            });
          } 
          // else if (error.status === 400) {
          //   this.toastr.error('Bad Request: Please check your input.');
          // } else if (error.status === 401) {
          //   this.toastr.error('Unauthorized: Please login again.');
          // } else if (error.status === 500) {
          //   this.toastr.error('Server Error: Please try again later.');
          // } else {
          //   this.toastr.error('An unexpected error occurred.');
          // }
          // console.error('Error:', error);
        }
      })
    // } else {
    //   this.markFormGroupTouched(this.leadForm);
    // }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if ((control as any).controls) {
        this.markFormGroupTouched(control as FormGroup);
      }
    });
  }
  
  // removeLeadingSpace(event: any) {
  //   const input = event.target;
  //   input.value = input.value.replace(/^\s+/, '');
  //   this.leadForm.get('name')?.setValue(input.value, { emitEvent: false });
  // }
  sanitizeInput(event: any, controlName: string) {
    let input = event.target;
    let value = input.value;
  
    // Remove leading whitespace
    value = value.replace(/^\s+/, '');
  
    // Optionally: Replace `. ` inserted by double space with single space
    value = value.replace(/\. $/, ' ');
  
    input.value = value;
    this.leadForm.get(controlName)?.setValue(value, { emitEvent: false });
  }
  
  cancel() {
    this.activeModal.dismiss('Cancelled');
  }
  
  onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
  
    // Remove invalid characters (allow only numbers)
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');
  
    // Prevent leading zeroes
    if (inputElement.value.startsWith('0')) {
      inputElement.value = inputElement.value.substring(1);
    }
  
    // If the first character is still zero, remove it
    this.restrictFirstPosition(event);
    // Add 'has-value' class if the input is not empty (for visual purposes)
    if (inputElement.value) {
      inputElement.classList.add('has-value');
    } else {
      inputElement.classList.remove('has-value');
    }

  }

  restrictFirstPosition(event: any): void {
    const input = event.target.value;
    if (input && input[0] === '0') {
      event.target.value = input.substring(1);  // Remove the leading zero
    }
  }
}
